module.exports = __webpack_public_path__ + "img/palette-1-bg_en.6ca5252.jpg";